import React, { FC, useEffect, useState } from 'react';
import s from './Checkout.module.scss';
import clsx from 'clsx';
import { ReactComponent as PenIcon } from 'images/new-icons/pen.svg';
import { ReactComponent as EditingCircle } from 'images/new-icons/editing-circle.svg';
import { ReactComponent as Unchecked } from 'images/new-icons/radiobuttonblack.svg';
import { ReactComponent as Checked } from 'images/new-icons/radiobuttonblackchecked.svg';
import Select from 'react-select';
import useGetSalonsAllowedCountries from 'sdk/hooks/useGetSalonsAllowedCountries';
import Button from 'components/shared/Button';

type Props = {
  address?: string;
  number?: string;
  isSelected?: boolean;
  isEditing?: boolean;
  onSelect?: () => void;
  onEdit?: (e: any) => void;
  item?: any;
  refetch?: any;
  updateAddress?: any;
};

const AddressCard: FC<Props> = ({
  address,
  number,
  onEdit,
  isSelected,
  onSelect,
  isEditing,
  item,
  refetch,
  updateAddress,
}) => {
  const { data: salonsAllowerCountries } = useGetSalonsAllowedCountries();

  const [newAddress, setNewAddress] = useState({
    city: item?.city,
    street: item?.street,
    apartment: item?.apartment,
    zip_code: item?.zip_code,
    state: item?.state,
    country: item?.country,
  });

  const countries = salonsAllowerCountries?.map(item => {
    return {
      value: item.id,
      label: item.country_name,
    };
  });

  const getCountry = countries?.find(el => el.label === item?.country);

  const handleChangeField = (field, e) => {
    setNewAddress({
      ...newAddress,
      [field]: e.target.value,
    });
  };

  const handleChangeCountry = e => {
    setNewAddress({
      ...newAddress,
      country: e.label,
    });
  };

  const onSubmit = () => {
    updateAddress(
      { newAddress, id: item?.id },
      {
        onError: error => {
          console.error('Failed to update gender:', error);
        },
        onSuccess: () => {
          onEdit && onEdit(null);
          refetch();
        },
      },
    );
  };

  useEffect(() => {
    setNewAddress({
      city: item?.city,
      street: item?.street,
      apartment: item?.apartment,
      zip_code: item?.zip_code,
      state: item?.state,
      country: item?.country,
    });
  }, [item?.id]);

  useEffect(() => {
    refetch();
  }, [item, refetch]);

  return (
    <>
      <div
        className={clsx(s.address_card, isSelected || isEditing ? s.selected : '')}
        onClick={onSelect}
      >
        <div className={clsx(s.card, isSelected || isEditing ? s.card_border : '')}>
          <div style={{ width: '100%' }}>
            <div className={s.card_header}>
              <div>
                {isSelected || isEditing ? <Checked /> : <Unchecked />}
              </div>
              <div
                style={{ marginLeft: 'auto' }}
                onClick={e => {
                  e.stopPropagation();
                  if (isEditing) {
                    onEdit && onEdit(null);
                    return;
                  }
                  onEdit && onEdit(item?.id);
                }}
              >
                <PenIcon />
              </div>
            </div>
            <div className={s.card_body}>
              <div className={s.card_body_title}>{address}</div>
              <div className={s.card_body_number}>+{number}</div>
              <div className={s.card_body_number}>{item?.user?.email}</div>
            </div>
          </div>
        </div>
      </div>
      {isEditing && (
        <div className={s.editing}>
          <input
            className={s.editing_text_field}
            defaultValue={item?.city}
            placeholder="City"
            onChange={e => handleChangeField('city', e)}
          />
          <input
            className={s.editing_text_field}
            defaultValue={item?.street}
            placeholder="Street"
            onChange={e => handleChangeField('street', e)}
          />
          <input
            className={s.editing_text_field}
            defaultValue={item?.apartment}
            placeholder="Apartment,
                        Suit, Unit (Optional)"
            onChange={e => handleChangeField('apartment', e)}
          />
          <input
            className={s.editing_text_field}
            defaultValue={item?.zip_code}
            placeholder="Postal Zip
                        Code"
            onChange={e => handleChangeField('zip_code', e)}
          />
          <input
            className={s.editing_text_field}
            defaultValue={item?.state}
            placeholder="State"
            onChange={e => handleChangeField('state', e)}
          />
          <Select
            options={countries}
            isClearable
            placeholder="Country/Region"
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: '1px solid #00000033',
                borderRadius: '12px',
                padding: '4px 8px',
                fontSize: '14px',
              }),
            }}
            defaultValue={getCountry}
            onChange={e => handleChangeCountry(e)}
          />
          <div className={s.editing_check}>
            <input type="checkbox" />
            <div className={s.editing_check_text}>Fullfill online orders from this location</div>
          </div>
          <Button
            wide
            purple
            onClick={onSubmit}
            disabled={
              !newAddress?.city ||
              !newAddress?.street ||
              !newAddress?.zip_code ||
              !newAddress?.country
            }
          >
            Save
          </Button>
        </div>
      )}
    </>
  );
};

export default AddressCard;
